import { Select as SelectAntd, SelectProps } from 'antd';

import FormField from '../Field';

const Select = ({ placeholder, children, value, showSearch = true, ...rest }: SelectProps) => (
  <SelectAntd
    showSearch={showSearch}
    placeholder={placeholder}
    value={value || undefined}
    filterOption={(input, option) =>
      ((option?.label ?? '') as string).toLowerCase().includes(input.toLowerCase())
    }
    {...rest}
  >
    {children}
  </SelectAntd>
);

const FormSelect = FormField<any>(Select);

export default FormSelect;
